import { usePropertyRentalMonthsToAccessFunding } from '../../../../queries/PropertyFields/RentalCoreFields';
import { ApplicationQuestionReviewItem } from '../../../components/ApplicationQuestionReviewItem';
import { DropDownBox } from '@apply/components';
import { MonthsToAccessFundingTypeOptions } from '@apply/constants';

export interface MonthsToAccessFundingProps {
    propertyGuid: string;
    width?: string;
    required?: boolean;
    isReview?: boolean;
}

export const MonthsToAccessFunding: React.FC<MonthsToAccessFundingProps> = ({
    propertyGuid,
    required = false,
    width,
    isReview = false,
}) => {
    const label = 'How long do you need access to draw funding?';
    const [monthsToAccessFunding, set_monthsToAccessFunding] = usePropertyRentalMonthsToAccessFunding(propertyGuid);

    const monthsToAccessFundingList = MonthsToAccessFundingTypeOptions.map((o) => ({
        display: o.name,
        value: o.id,
    }));

    const findMonthsToAccessFundingByValue = (value: number | undefined) => {
        return monthsToAccessFundingList.find((bt) => bt.value == value)?.display;
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={findMonthsToAccessFundingByValue(monthsToAccessFunding)}
                />
            ) : (
                <DropDownBox
                    id={'monthsToAccessFundingDropDown'}
                    value={monthsToAccessFunding}
                    onChange={(value) => set_monthsToAccessFunding(value)}
                    required={required}
                    dataSource={monthsToAccessFundingList}
                    displayExpr='display'
                    valueExpr='value'
                    width={width}
                    label={label}
                />
            )}
        </>
    );
};
